import { Component, OnInit, Input, Output, EventEmitter, ViewChildren, QueryList, Injector, OnChanges, SimpleChanges } from '@angular/core';
import { DialogsService } from 'src/app/services/shared/dialogs.service';

@Component({
    selector: 'app-situation',
    templateUrl: './situation.component.html',
    styleUrls: ['./situation.component.scss'],
    standalone: false
})
export class SituationComponent implements OnInit, OnChanges {
  @Input() typeSituacion: string = '';
  @Input() arrayPeriodosHist: any;
  @Input() variants: any;
  @Input() changePeriods: any;
  @Input() changeSituation: any;
  @Input() isEditing: boolean;
  @Input() isCreating: boolean;
  @Input() iCanRegistros: number = 0;
  @Output() setPeriods: EventEmitter<any> = new EventEmitter<any>();
  @Output() setAllPeriods: EventEmitter<any> = new EventEmitter<any>();
  @Output() setSituation: EventEmitter<any> = new EventEmitter<any>();
  public periodosMostrar: number = 60;
  page: number = 0;
  lastValidAcomula = {};
  @ViewChildren('identificador') components: QueryList<any>;
  @ViewChildren('identificadorAcumula') componentsAcumula: QueryList<any>;
  private dialogo: DialogsService;
  constructor(
    injector: Injector,
  ) {
    this.dialogo = injector.get<DialogsService>(DialogsService)
  }

  ngOnInit(): void {

  }

  ngAfterViewInit() {
    if (this.typeSituacion === 'situation') {
      console.log('%c ' + 'situationComponent' + " / " + 'ngAfterViewInit()', 'background: purple; color: black');
      console.log("this.variants.currentObject : ", JSON.parse(JSON.stringify(this.variants.currentObject)));

      this.componentsAcumula.changes.subscribe(() => {
        this.setAcumulaNavigator();
      })
    }
  }

  ngOnChanges(changes: SimpleChanges): void {

    this.iCanRegistros = this.arrayPeriodosHist ? this.arrayPeriodosHist.length : 0;

    console.log("this.iCanRegistros ngOnChanges ------>", this.iCanRegistros);
    console.log("this.arrayPeriodosHist ngOnChanges ---->", this.arrayPeriodosHist);

    if (changes.arrayPeriodosHist && this.arrayPeriodosHist !== undefined && this.arrayPeriodosHist.length > 0) {
      const lastPeriod = this.arrayPeriodosHist.reduce((maxPeriodo, object) => {
        if (object.periodo > maxPeriodo.periodo) {
          return object;
        } else {
          return maxPeriodo;
        }
      }, this.arrayPeriodosHist[0]);

      if (lastPeriod) {
        this.selectPeriods(lastPeriod);
      }
      if (this.typeSituacion === 'situation') {
        this.getLastValidAcumula();
      }

    }
    if (changes.changeSituation) {
      if (changes.changeSituation.currentValue !== changes.changeSituation.previousValue) {

        if (this.isEditing) {
          const index = this.arrayPeriodosHist.findIndex(x => x.fecha === this.changeSituation.periods);

          if (index !== -1) {
            const situacion = this.changeSituation.value;
            this.arrayPeriodosHist[index].situacion = situacion;
            this.arrayPeriodosHist[index].situacion_new = situacion;
          }

        }
      }
    }


    if (changes.changePeriods) {

      if (changes.changePeriods.currentValue !== changes.changePeriods.previousValue) {
        this.selectPeriods(this.changePeriods);
      }

    }
  }

  prevHistorical() {
    if (this.page > 0) {
      this.page -= 24
    }
  }

  nextHistorical() {
    if (this.page < this.iCanRegistros) {
      if ((this.periodosMostrar - this.page) >= 24) {
        this.page += 24
      }
    }
  }

  async updateAllPeriod() {
    const { situation, originalHistoric, currentObject, title } = this.variants;

    const list = situation.map(situation => {
      return {
        code: situation.value,
        description: situation.text
      }
    })
    const config = {
      height: 'auto',
      width: '678px',
      data: {
        subdomain: title,
        message: 'Editando todos los periodos',
        content: 'data',
        list
      }
    }

    const res = await this.dialogo.muestraMensaje('message', config);

    if (res.status) {

      // set new situacion
      let situacionTemp_cod = res.value;

      const situacionTempDes = list.find(x => x.code === situacionTemp_cod).description;

      const changeEdit = [];
      this.arrayPeriodosHist.forEach(element => {

        if (element.editable === 'S') {
          let tempPeriods = currentObject.find(x => x.periodo === element.periodo);

          tempPeriods.situacion_cod = situacionTemp_cod;
          tempPeriods.situacion_desc = situacionTempDes;
          tempPeriods.operacion_tipo = "MODIF";
          tempPeriods.fuente_tipo = "M";

          tempPeriods.fuente = "DATA MAINTENANCE";
          changeEdit.push(tempPeriods);

        }

      });

      this.setAllPeriods.emit(changeEdit);

    }
  }


  selectPeriods(data) {


    const arrayPeriodosHist = this.arrayPeriodosHist.map((x: any) => {
      if (x.active) {
        x.active = false;
      }
      if (this.typeSituacion !== 'situation') {
        if (x.day === data.day && x.month === data.month && x.year === data.year) {
          x.active = true;
        }
      } else {
        if (x.mes === data.mes && x.anio === data.anio) {
          x.active = true;
        }
      }
      return x;
    });

    const periods = `${data.anio}${data.mes}`;

    let periodsActual: any = this.typeSituacion !== 'situation' ? data
      : this.variants.currentObject.find(x => String(x.periodo) === String(periods));

    let type = "";





    if (periodsActual === undefined) {
      const findData = this.variants.currentObject.find(x => String(x.periodo) !== "");

      const atributes = Object.keys(findData);

      periodsActual = {};
      atributes.forEach(atribute => {
        if (this.variants.matrizValueDefault.includes(atribute) || atribute === 'iup') {
          periodsActual[atribute] = findData[atribute]
        } else if (atribute === "periodo") {
          periodsActual[atribute] = periods;
        } else if (atribute === "matchKey") {
          const subString = findData[atribute].substring(0, findData[atribute].length - 6);

          const matchKey = `${subString}${periods}`
          periodsActual[atribute] = matchKey;

        } else if (atribute === "fuente_fh") {
          const date = new Date();
          const anao = String(date.getFullYear());
          const mm = String(date.getMonth() + 1).padStart(2, '0');
          const dd = String(date.getDate()).padStart(2, '0');
          const fuenteFh = anao + mm + dd;
          periodsActual[atribute] = Number(fuenteFh);
        } else {
          const exist = this.variants.fieldsNoEdit.some(x => x.name === atribute);
          periodsActual[atribute] = exist ? findData[atribute] : "";
        }

      })
      type = "add";
    } else {
      type = "edit"
    }

    const setData = {
      arrayPeriodosHist,
      periodsActual,
      typePeriods: this.typeSituacion,
      type
    }
    this.setPeriods.emit(setData);

  }

  onChangeSituacion(event: any) {

    const value = event.target.value;
    const situacion = this.variants.situation;

    const validateSituation = situacion.find(x => x.value === String(value));

    if (event.data !== null && event.data !== '') {
      event.target.value = String(event.data).toUpperCase();
    }

    if (validateSituation === undefined && value !== '') {

      this.dialogo.muestraMensaje("¡Situación ingresada no corresponde!");
      event.target.value = "";
    } else {

      const situation = {
        params: "situacion_cod",
        value
      }
      this.setSituation.emit(situation);
    }
    console.log("this.variants", this.variants);


  }

  checkNextSituacion(event: any) { }

  changeToPediod(periods: string) {

    this.components.forEach((element) => {

      if (String(element.nativeElement.id) === String(periods)) {
        element.nativeElement.classList.add('bg-primary');
        element.nativeElement.focus();
        element.nativeElement.select();
      } else {
        element.nativeElement.classList.remove('bg-primary');
        element.nativeElement.setAttribute('style', 'text-align: center; width: 25px;');
      }
    })
  }

  getLastValidAcumula() {
    console.log('%c ' + 'situationComponent' + " / " + 'getLastValidAcumula()', 'background: purple; color: black');

    this.lastValidAcomula = {}

    const { type } = this.variants;

    let sortedPeriod = this.variants.originalHistoric[type].sort((a: any, b: any) => this.itemPeriodo(a.periodo) > this.itemPeriodo(b.periodo) ? -1 : 1)

    for (let element of sortedPeriod) {
      if (element.acumula != null && element.acumula != "" && element.acumula != " ") {
        if (element.acumula === "B") {
          this.lastValidAcomula["acumula"] = element["acumula"];
          this.lastValidAcomula["periodo"] = element["periodo"];
          break
        }
      }
    }
    console.log("this.lastValidAcomula", this.lastValidAcomula);

    this.setAcumulaNavigator()
  }


  setAcumulaNavigator() {
    console.log('%c ' + 'situationAcumula' + " / " + 'setAcumulaNavigator()', 'background: purple; color: black');
    console.log("componentsAcumula : ", this.componentsAcumula);
    console.log("this.lastValidAcomula[periodo] :", this.lastValidAcomula["periodo"]);

    this.componentsAcumula.forEach((element) => {
      if (element.nativeElement.id === "month_" + this.lastValidAcomula["periodo"]) {
        element.nativeElement.setAttribute('style', 'height: 30px; display: flex; align-items: center; cursor: pointer; border: 1px #9e1b32 solid; width: 24px;color: white;justify-content: center;background-color: #9e1b32;');
      } else {
        element.nativeElement.setAttribute('style', 'height: 30px; display: flex; align-items: center; cursor: pointer;');
      }
    })
  }

  itemPeriodo(oldPeriodo: any) {
    let newPeriodo = oldPeriodo;
    if (String(oldPeriodo).length === 8) {
      if (typeof oldPeriodo === "string") {
        newPeriodo = String(oldPeriodo).slice(0, -2);
      } else if (typeof oldPeriodo === "number") {
        newPeriodo = Number(String(oldPeriodo).slice(0, -2));
      }
    }
    return newPeriodo;
  }

}
